import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 mt-8" }

import { ref, computed, onMounted } from 'vue';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-vue';
import ModalDialog from '../ModalDialog/ModalDialog.vue';
import { QuoteSessionService as _quoteSessionService } from '@/services/store/quote-session.service';
import { JP_GENERIC_CODE } from '@/constants/jeopardy-codes.const';
import { useAccountStore, useJeopardyStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DiscardModal',
  props: {
    description: {},
    showByDefault: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// Define Component state
// ------------------------------------------------------------- //
const accountStore = useAccountStore();
const jpStore = useJeopardyStore();

const showDiscardModal = ref(false);
const isLoading = ref(false);

const quoteSessionId = computed(() => {
  const params = new URLSearchParams(location.search);
  return params.get('quoteSessionId') ?? '';
});

// Lifecycle hooks
// ------------------------------------------------------------- //
onMounted(() => {
  if (props.showByDefault) {
    showDiscardModal.value = true;
  }
});

// Define Functions
// ------------------------------------------------------------- //
async function withdrawQuoteSession() {
  const response = await _quoteSessionService.withdrawQuoteSession(quoteSessionId.value ?? '');
  if (response.errors && response.errors.length > 0) {
    throw response.errors[0].message ?? JP_GENERIC_CODE;
  }
  return response;
}
function showJeopardyPanel(jpCode: string) {
  jpStore.showJeopardyPanel({
    jpCode: jpCode,
  });
}

async function discardChanges() {
  try {
    isLoading.value = true;
    await withdrawQuoteSession();
    await accountStore.cancelForm();
    isLoading.value = false;
    showDiscardModal.value = false;
  } catch (e) {
    console.error('Error discarding session quote', e);
    showJeopardyPanel(e as string);
  } finally {
    isLoading.value = false;
    showDiscardModal.value = false;
  }
}

function showHideModal(show: boolean) {
  showDiscardModal.value = show;
}

__expose({
  showHideModal,
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(ModalDialog, {
    modelValue: showDiscardModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDiscardModal).value = $event)),
    closeOnEsc: true,
    showXCloseButton: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(RichText), {
        class: "richtext",
        field: _ctx.description
      }, null, 8, ["field"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FormKit, {
          type: "button",
          inputClass: "btn btn-primary btn-md w-full",
          label: "No",
          onClick: _cache[0] || (_cache[0] = () => (showDiscardModal.value = false))
        }),
        _createVNode(_component_FormKit, {
          type: "button",
          loading: isLoading.value,
          inputClass: "btn btn-secondary btn-md w-full",
          label: "Yes",
          onClick: discardChanges
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})